import { render } from "./completed-case-card.vue?vue&type=template&id=3ab0dc49&scoped=true"
import script from "./completed-case-card.vue?vue&type=script&lang=js"
export * from "./completed-case-card.vue?vue&type=script&lang=js"

import "./completed-case-card.vue?vue&type=style&index=0&id=3ab0dc49&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab0dc49"]])

export default __exports__